module.exports = __webpack_public_path__ + "83d76e72abaa1b4e2170fe4233edc838.png";